export default {
  VAT: 'VAT Number',
  CUIT: 'CUIT',
  ABN: 'ABN',
  RFC: 'RFC',
  GST: 'GST'
};
